/**
 * @description Fonction Used to get the public environment variables
 * @param envName
 * @returns {string}
 */
export const getPublicRuntimeConfig = (envName: string): string =>
  process.env[envName] ?? '';
